export default __webpack_public_path__ + "static/media/intro-bg8.9a0d8240.MP4";